import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {
  transform(value: string): number {
    const retNumber = Number(value);
    return isNaN(retNumber) || !isFinite(retNumber) ? 0 : retNumber;
  }
}
